import { CardContent } from "@mui/material";
import { MprcCard, MprcContainer } from "components";
import { MprcRecordInfo } from "components/MprcRecordInfo";
import { RecordInfoDto } from "generated/CoreApi_v1";
import React from "react";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    recordInfo: RecordInfoDto;
    unitTypeId: string;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Rodapé de Tipos de Unidade Administrativa
 * @param props
 */
export const EditUnitTypeFooter: React.FC<IProps> = ({ unitTypeId, recordInfo }) => {
    return (
        <MprcContainer>
            <MprcCard>
                <CardContent>
                    <MprcRecordInfo recordInfo={recordInfo} />
                </CardContent>
            </MprcCard>
        </MprcContainer>
    );
};
